import Hero from './components/Hero';
import Positioning from './components/Positioning';
import Industries from './components/Industries';
import AtlasFramework from './components/AtlasFramework';
import Results from './components/Results';
import Differentiation from './components/Differentiation';
import FinalCTA from './components/FinalCTA';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="font-['Inter']">
      <Navigation />
      <Hero />
      <Positioning />
      <Industries />
      <AtlasFramework />
      <Results />
      <Differentiation />
      <FinalCTA />
      <Footer />
    </div>
  );
}